import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    assetErrorMessage: string;
    folderErrorMessage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            assetErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRenameAsset.assetErrorMessage?c=35qmii1d5q7e4", defaultMessage: "Couldn''t rename asset." }));
                },
                enumerable: true,
                configurable: true
            },
            folderErrorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useRenameAsset.folderErrorMessage?c=2qxym0xt1d6z7", defaultMessage: "Couldn''t rename folder." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
